









import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    bold: { type: Boolean, default: false },
  },
});
